import {gql, useQuery} from "@apollo/client";
import {Box, Flex, Spinner} from "@chakra-ui/react"
import ThemeCard from "../../../components/card/ThemeCard";
import React from "react";

const getAllThemesAndTopics = gql`query GetAllThemesAndTopics($customer: String = "") {
  themes(where: {customer: {_eq: $customer}}) {
    data
    theme_id
    theme_name
    description
    topics {
      topic_name
      topic_id
      data
      topic_definitions {
        type
        query
        data
        topic_definition_to_reasons(where: {customer: {_eq: $customer}}, limit: 100, order_by: {text: {timestamp_original: desc}}) {
          reason_text
          term
          text_id
          type
          reason_id
          text {
            text
          }
        }
      }
    }
  }
}
`

export default function ThemesPage() {
    let {loading, error, data: themesData} = useQuery(getAllThemesAndTopics,
        {
            variables: {"customer": localStorage.getItem("customerName")}
        }
    )
    if (error) console.log("GetAllThemesAndTopics query failed", error)
    if (!loading) console.log('themesData', themesData);

    return (
        <Flex flexDirection="column" px='30px' gap='10px' py='0px'>
            {(loading) ? <Box pt={{base: "130px", md: "80px", xl: "80px"}}><Spinner/></Box> :
                themesData.themes.map((themeData, idx) => (
                    <ThemeCard themeData={themeData} key={idx}/>

                ))}
        </Flex>
    )
}